import type React from 'react'

import {Grid, Stack, Text} from '@primer/react-brand'
import type {Person} from '../../lib/types/contentful'

import ProfileCard from './ProfileCard'
import styles from './People.module.css'

type PeopleProps = {
  label: string
  people: Person[]
}

export const People: React.FC<PeopleProps> = ({label, people}) => (
  <Stack padding="none" gap={24}>
    <Text>{label}</Text>
    <Grid className={styles.peopleGrid}>
      {people.map(person => (
        <Grid.Column span={{small: 12, medium: 6}} key={person.sys.id}>
          <ProfileCard person={person} />
        </Grid.Column>
      ))}
    </Grid>
  </Stack>
)
